import { string, instanceOf } from 'prop-types';

import { rem } from '@blueprint/ui';

import { useSafeLabel } from 'hooks';
import { ScreenReaderOnly } from 'components/ScreenReaderOnly/ScreenReaderOnly';
import { Text } from 'components/blueprint';
import { formatMessageTime } from 'utils/formatMessageTime';

import messages from './messages';

export const ReplyMeta = ({ role, time }) => {
  const safeLabel = useSafeLabel();

  return (
    <Text
      displayBlock
      variant="body2"
      marginLeft={rem(8)}
      marginBottom={rem(4)}
      lineHeight={1.33}
    >
      {`${role}`}
      <ScreenReaderOnly>
        {safeLabel(messages.saidAtTime, { time: formatMessageTime(time) })}
      </ScreenReaderOnly>
    </Text>
  );
};

ReplyMeta.propTypes = {
  /**
   * Role of the reply
   */
  role: string.isRequired,
  /**
   * Time for the message
   */
  time: instanceOf(Date).isRequired,
};
